import MembershipStatusResourceModel from '../../generated/types/model/resource/MembershipStatusResourceModel';

export default class MembershipStatusResourceViewModel extends MembershipStatusResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
